import { observer } from 'mobx-react-lite'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import { type CallCenterSelectionViewModel } from '@/features/call-center/CallCenterSelectionViewModel'
import { type CallCenterJobHistoryViewModel } from '@/features/call-center/CallCenterJobHistoryViewModel'
import {
  ClientDetails,
  JobHistoryCard,
} from '@/features/call-center/ClientDetails'

export interface ClientDetailsContainerProps {
  vm: CallCenterSelectionViewModel
  jobHistoryVm: CallCenterJobHistoryViewModel
  onAddToWorkspace: () => void
}

export const ClientDetailsContainer = observer(function ClientDetailsContainer({
  vm,
  jobHistoryVm,
  onAddToWorkspace,
}: ClientDetailsContainerProps) {
  if (!vm.selectedResult) {
    return null
  }

  return (
    <ClientDetails
      fullName={vm.fullName}
      email={vm.email}
      phone={vm.phone}
      membershipEntries={vm.membershipEntryVms.map((itemVm) => ({
        key: itemVm.item.key,
        workspaceName: itemVm.workspaceName,
        isWaitlistWorkspace: itemVm.item.isWaitlistWorkspace,
        lastSeen: itemVm.lastSeen,
        canCreateJob: itemVm.canCreateJob,
        onCreateJob: itemVm.createJob,
      }))}
      waitlistEntries={vm.waitlistEntryVms.map((itemVm) => ({
        key: itemVm.item.key,
        workspaceName: itemVm.workspaceName,
        loading: itemVm.item.loading,
        error: itemVm.item.error,
        isInviteDisabled: itemVm.isInviteDisabled,
        onInvite: itemVm.invite,
      }))}
      shouldShowEmptyMembership={vm.shouldShowEmptyMembership}
      onAddToWorkspace={onAddToWorkspace}
      jobHistory={<JobHistoryCardContainer vm={jobHistoryVm} />}
    />
  )
})

interface JobHistoryCardContainerProps {
  vm: CallCenterJobHistoryViewModel
}

const JobHistoryCardContainer = observer(function JobHistoryCardContainer({
  vm,
}: JobHistoryCardContainerProps) {
  const scroller = vm.jobsScroller

  return (
    <JobHistoryCard
      failed={!!scroller.fetch.error}
      isEmpty={
        vm.jobs.length === 0 && scroller.isDone && !scroller.fetch.pending
      }
      jobs={vm.jobVms.map((jobVm) => ({
        id: jobVm.job.id,
        shortId: jobVm.job.shortId,
        name: jobVm.job.name,
        workspaceName: jobVm.job.workspace.name,
        statusText: jobVm.statusText,
        dateCreated: jobVm.job.dateCreated,
        specs: jobVm.specs,
        total: jobVm.job.total,
        navigable: jobVm.isNavigable,
      }))}
      loader={
        !scroller.isDone && (
          <InfiniteScrollLoaderContainer scrollProvider={scroller} compact />
        )
      }
    />
  )
})
